export default "__VITE_ASSET__DQ9XLK72__"